import React, { FC, useState } from 'react';
import {
  Text,
  Input,
  Tooltip,
  Skeleton,
} from '@cubeyou-team/hx-react-components';
import styled from 'styled-components';

const StyledQueryTargetTitle = styled.div`
  display: flex;
  flex-direction: column;
  width: 80%;
`;

const StyledInputText = styled.div`
  input:focus {
    color: ${props => props.color};
    border-color: ${props => props.color};
    text-transform: uppercase;
  }
`;

const StyledText = styled(Text)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  border-bottom: 2px dotted
    ${props => (props.selected ? 'white' : 'rgb(241,240,255)')};
  cursor: text;

  max-width: 100%;
  min-width: 100%;
  color: ${props => props.color};
  opacity: ${props => (props.selected ? 1 : 0.3)};
  ${props =>
    props.selected && `&:hover { border-bottom: 2px dotted ${props.color} }`};
`;

const QueryTargetSizeLoader = () => {
  return (
    <div className="flex items-center justify-center">
      <Skeleton speed={2} width={70} height={15} viewBox="0 0 70 15">
        <rect x="0" y="0" rx="50" ry="50" width="10" height="10" />
        <rect x="15" y="0" rx="50" ry="50" width="10" height="10" />
        <rect x="30" y="0" rx="50" ry="50" width="10" height="10" />
      </Skeleton>
    </div>
  );
};
const QueryTargetTitle: FC<any> = ({
  title,
  textTitle,
  color,
  size,
  isDisabled,
  isLoading,
  onTitleChange,
  selected,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  return (
    <StyledQueryTargetTitle>
      {isEditing && !isDisabled ? (
        <StyledInputText color={color}>
          <Input
            type="text"
            name="tab-edit"
            size="thin"
            value={title}
            onChange={e => {
              e.persist();
              onTitleChange(e.target.value);
            }}
            onBlur={() => setIsEditing(false)}
            autoFocus
            style={{ width: '100%' }}
          />
        </StyledInputText>
      ) : (
        <Tooltip content={textTitle} position="right" isInfoLabel>
          <StyledText
            size="xbody"
            align="center"
            weight="bold"
            lettercase="uppercase"
            color={color}
            selected={selected}
            onClick={e => {
              e.persist();
              setIsEditing(true);
            }}
          >
            {textTitle}
          </StyledText>
        </Tooltip>
      )}
      {!isLoading ? (
        <Text
          size="xsmall"
          align="center"
          weight="bold"
          style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            width: '100%',
            maxWidth: '100%',
            minWidth: '100%',
            color,
            opacity: selected ? 1 : 0.3,
          }}
        >
          {`Size ${size}`}
        </Text>
      ) : (
        <QueryTargetSizeLoader />
      )}
    </StyledQueryTargetTitle>
  );
};
export default QueryTargetTitle;
